export default (theme) => ({
    row5: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        '& .MuiTextField-root': {
            width: '15% !important',
        },
        '& .MuiTextField-root.row3, & .MuiAutocomplete-root.row3': {
            width: '60% !important',
            '& .MuiTextField-root' : {
                width: '100% !important',
            }
        },
    },
    row4: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        '& .MuiTextField-root': {
            //     margin: theme.spacing(1),
            width: '20% !important',
        },
        '& .MuiTextField-root.row2': {
            //     margin: theme.spacing(1),
            width: '55% !important',
        },
    },
    row3: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        '& .MuiTextField-root': {
            //     margin: theme.spacing(1),
            width: '95% !important',
        },
        '& .MuiTextField-root.row2': {
            //     margin: theme.spacing(1),
            width: '65% !important',
        },
    },
    row2: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        '& .MuiTextField-root, & .MuiAutocomplete-root': {
            //     margin: theme.spacing(1),
            width: '95% !important',
        },
        '& .MuiAutocomplete-root .MuiTextField-root': {
            width: '100% !important',
        }
    },
    formInput: {
        width: '100%',
    },
    inputWithAddButton: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        '& > div:first-child': {
            width: '100%'
        }
    },
    addButton: {
        paddingTop: '15px'
    },
    verticalCenter: {
        alignItems: 'center'
    },
    image: {
        border: '1px dashed',
        borderColor: theme.palette.primary.light,
        backgroundImage: 'url(http://testcrm.lp-crm.biz/style/img/no_foto-120x100.png)',
        minHeight: '150px',
        width: '60%',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
    },
    imageUploadButton: {
        // margin: '20px auto 0 auto',
        width: '100%',
    },
});
